import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import {SplitText} from 'gsap/SplitText'
import 'is-in-viewport'
import {onScroll} from './transition'

gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText)

function allElementsExist() {
  for (const c of arguments) {
    if (!document.querySelector(c)) {
      return false
    }
  }
  return true
}

let startUpscroll = 0;
export const scrollSmoother = ScrollSmoother.create({
  smooth: window.matchMedia('(hover: none)').matches ? 0 : 2,
  speed: 1,
  effects: true,
  onUpdate: (self) => {
    onScroll(self)
    onUpdateScrollMenu(self)
  },
  onStop: () => onScroll,
})

function onUpdateScrollMenu(self) {
  const threshold = 20;
  const scrollTarget = $('html')
  const velocity = self.getVelocity()
  const currentScroll = self.scrollTop();
  const documentScroll = $(document).scrollTop();
  const atTop = currentScroll <= 1;

  scrollTarget.addClass('scrolling').removeClass('at-top')
  if (atTop) {
    scrollTarget.removeClass('scroll-down scrolling scroll-up').addClass('at-top')
  } else {
    if (velocity > 0) {
      scrollTarget.addClass('scroll-down').removeClass('scroll-up')
      startUpscroll = documentScroll;
    } else if (velocity < 0 && startUpscroll - documentScroll >= threshold) {
      scrollTarget.removeClass('scroll-down').addClass('scroll-up')
    }
  }
}

ScrollTrigger.config({ignoreMobileResize: true})
ScrollTrigger.normalizeScroll(true)

for (const animatedTextElement of gsap.utils.toArray('.animated-text')) {
  let split = SplitText.create(animatedTextElement, {
    type: 'words',
    wordsClass: 'word-inner',
  })

  split.words.forEach((word) => {
    const mask = document.createElement('div')
    mask.classList.add('word-mask')
    mask.style.overflow = 'hidden'
    mask.style.display = 'inline-block'
    word.parentNode.insertBefore(mask, word)
    mask.appendChild(word)
  })

  gsap.set(split.words, {
    display: 'inline-block',
    y: '50%',
    opacity: 0,
  })

  split.words.forEach((word) => {
    gsap.to(word, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power4.inOut',
      scrollTrigger: {
        trigger: word,
        start: 'top 95%',
        once: true,
      },
    })
  })
}

if (allElementsExist('.block-heroBlock', '.hero-image', '.hero-image-container')) {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.hero-image-container',
      start: 'top bottom',
      end: 'top top',
      scrub: true,
      invalidateOnRefresh: true,
    },
  })

  timeline.to('.hero-image-container', {
    width: () => (window.innerWidth < 1024 ? window.innerWidth : window.innerWidth * 0.8),
    y: -42,
  })
  timeline.to('.hero-image', {scale: 1}, '<')
  timeline.to(
    '.hero-text',
    {
      x: () => (-window.innerWidth * (0.8 - 0.325)) / 2,
    },
    '<',
  )

  document.querySelector('.site-header').classList.add('delayed')
}

document.querySelector('.site-header').classList.remove('once')

setTimeout(() => {
  document.querySelector('.site-header').classList.remove('delayed')
}, 1200)

document.querySelectorAll('.hero-video-container').forEach((el) => {
  el.addEventListener('mouseenter', () => tween.pause())
  el.addEventListener('mouseleave', () => tween.resume())
})
